export const PUBLIC_ROUTES = [
  '/',
  '/tips',
  '/signup',
  '/premium',
  '/verification',
  '/reset',
  '/recover',
  '/login',
  '/worldcup',
  '/auth',
];
export const BRAZE_CODES = {
  dev: '2fa7f3d6-56c1-40d3-bdc5-e3f1e9209489',
  prod: 'f7dac103-3a77-4a98-b9fd-ad57e485c020',
};

export const COUNTRY_CODES_DICTIONARY = {
  bro81ds2eusrqhpr4lug: 'ES',
  bru4eps2eusub6g52or0: 'BR',
  bru4eps2eusub6g52oa0: 'MX',
  bru4eps2eusub6g52npg: 'AD',
  bru4eps2eusub6g52nm0: 'US',
  bru4eps2eusub6g52m80: 'PT',
  bru4eps2eusub6g52nf0: 'PE',
  bru4eps2eusub6g52ok0: 'CO',
};

export const SPORTS_LIST = [
  {
    id: 'bif6kkbp0dp4vp059t0g',
    value: 'soccer',
    label: 'Fútbol',
    key: 'soccer',
    title: 'Fútbol',
  },
  {
    id: 'bif6kkjp0dp4vp059t10',
    value: 'tennis',
    label: 'Tenis',
    key: 'tennis',
    title: 'Tenis',
  },
  {
    id: 'bif6kkrp0dp4vp059t1g',
    value: 'ice-hockey',
    label: 'Hockey sobre hielo',
    key: 'ice-hockey',
    title: 'Hockey sobre hielo',
  },
  {
    id: 'bif6kkrp0dp4vp059t20',
    value: 'handball',
    label: 'Balonmano',
    key: 'handball',
    title: 'Balonmano',
  },
  {
    id: 'bif6kkrp0dp4vp059t2g',
    value: 'basketball',
    label: 'Baloncesto',
    key: 'basketball',
    title: 'Baloncesto',
  },
  {
    id: 'bif6kl3p0dp4vp059t30',
    value: 'american-football',
    label: 'Fútbol Americano',
    key: 'american-football',
    title: 'Fútbol Americano',
  },
  {
    id: 'bif6kl3p0dp4vp059t3g',
    value: 'baseball',
    label: 'Béisbol',
    key: 'baseball',
    title: 'Béisbol',
  },
  {
    id: 'bif6kl3p0dp4vp059t40',
    value: 'rugby-union',
    label: 'Rugby Union',
    key: 'rugby-union',
    title: 'Rugby Union',
  },
  {
    id: 'bif6kljp0dp4vp059t60',
    value: 'rugby-league',
    label: 'Rugby League',
    key: 'rugby-league',
    title: 'Rugby League',
  },
  {
    id: 'bif6klbp0dp4vp059t4g',
    value: 'volleyball',
    label: 'Vóleibol',
    key: 'volleyball',
    title: 'Vóleibol',
  },
  {
    id: 'bif6klbp0dp4vp059t50',
    value: 'futsal',
    label: 'Futsal',
    key: 'futsal',
    title: 'Futsal',
  },
  {
    id: 'bif6kljp0dp4vp059t5g',
    value: 'esports',
    label: 'Esports',
    key: 'esports',
    title: 'Esports',
  },
  {
    id: 'boffjln2s2m9mfqtatkg',
    value: 'squash',
    label: 'Squash',
    key: 'squash',
    title: 'Squash',
  },
  {
    id: 'bq3gno42eusphmf48vf0',
    value: 'table-tennis',
    label: 'Tenis de mesa',
    key: 'table-tennis',
    title: 'Tenis de mesa',
  },
  {
    id: 'bqephof96j4dnfcducb0',
    value: 'darts',
    label: 'Dardos',
    key: 'darts',
    title: 'Dardos',
  },
  {
    id: 'btrki7n96j49qd0pcbm0',
    value: 'cycling',
    label: 'Ciclismo',
    key: 'cycling',
    title: 'Ciclismo',
  },
  {
    id: 'btrkip796j4a7s6sjfn0',
    value: 'martial-arts',
    label: 'Artes Marciales',
    key: 'martial-arts',
    title: 'Artes Marciales',
  },
  {
    id: 'btrkipf96j4a6dj9vnm0',
    value: 'motor',
    label: 'Motor',
    key: 'motor',
    title: 'Motor',
  },
  {
    id: 'btrkipn96j4a6uvf8vdg',
    value: 'paddle',
    label: 'Padel',
    key: 'paddle',
    title: 'Padel',
  },
  {
    id: '',
    value: 'other',
    label: 'Otros',
    key: 'other',
    title: 'Otros',
  },
];
export const COUNTRIES_DICTIONARY = {
  afg: 'Afganistán',
  ala: 'Åland',
  alb: 'Albania',
  deu: 'Alemania',
  and: 'Andorra',
  ago: 'Angola',
  aia: 'Anguila',
  ata: 'Antártida',
  atg: 'Antigua y Barbuda',
  sau: 'Arabia Saudita',
  dza: 'Argelia',
  arg: 'Argentina',
  arm: 'Armenia',
  abw: 'Aruba',
  aus: 'Australia',
  aut: 'Austria',
  aze: 'Azerbaiyán',
  bhs: 'Bahamas',
  bgd: 'Bangladés',
  brb: 'Barbados',
  bhr: 'Baréin',
  bel: 'Bélgica',
  blz: 'Belice',
  ben: 'Benín',
  bmu: 'Bermudas',
  blr: 'Bielorrusia',
  bol: 'Bolivia',
  bes: 'Bonaire, San Eustaquio y Saba',
  bih: 'Bosnia y Herzegovina',
  bwa: 'Botsuana',
  bra: 'Brasil',
  brn: 'Brunéi',
  bgr: 'Bulgaria',
  bfa: 'Burkina Faso',
  bdi: 'Burundi',
  btn: 'Bután',
  cpv: 'Cabo Verde',
  khm: 'Camboya',
  cmr: 'Camerún',
  can: 'Canadá',
  qat: 'Catar',
  tcd: 'Chad',
  chl: 'Chile',
  chn: 'China',
  cyp: 'Chipre',
  col: 'Colombia',
  com: 'Comoras',
  prk: 'Corea del Norte',
  kor: 'Corea del Sur',
  civ: 'Costa de Marfil',
  cri: 'Costa Rica',
  hrv: 'Croacia',
  cub: 'Cuba',
  cuw: 'Curazao',
  dnk: 'Dinamarca',
  dma: 'Dominica',
  ecu: 'Ecuador',
  egy: 'Egipto',
  slv: 'El Salvador',
  are: 'Emiratos Árabes Unidos',
  eri: 'Eritrea',
  svk: 'Eslovaquia',
  svn: 'Eslovenia',
  esp: 'España',
  usa: 'Estados Unidos',
  est: 'Estonia',
  eth: 'Etiopía',
  phl: 'Filipinas',
  fin: 'Finlandia',
  fji: 'Fiyi',
  fra: 'Francia',
  gab: 'Gabón',
  gmb: 'Gambia',
  geo: 'Georgia',
  gha: 'Ghana',
  gib: 'Gibraltar',
  grd: 'Granada',
  grc: 'Grecia',
  grl: 'Groenlandia',
  glp: 'Guadalupe',
  gum: 'Guam',
  gtm: 'Guatemala',
  guf: 'Guayana Francesa',
  ggy: 'Guernsey',
  gin: 'Guinea',
  gnb: 'Guinea-Bisáu',
  gnq: 'Guinea Ecuatorial',
  guy: 'Guyana',
  hti: 'Haití',
  hnd: 'Honduras',
  hkg: 'Hong Kong',
  hun: 'Hungría',
  ind: 'India',
  idn: 'Indonesia',
  irq: 'Irak',
  irn: 'Irán',
  irl: 'Irlanda',
  bvt: 'Isla Bouvet',
  imn: 'Isla de Man',
  cxr: 'Isla de Navidad',
  isl: 'Islandia',
  cym: 'Islas Caimán',
  cck: 'Islas Cocos',
  cok: 'Islas Cook',
  fro: 'Islas Feroe',
  sgs: 'Islas Georgias del Sur y Sandwich del Sur',
  hmd: 'Islas Heard y McDonald',
  flk: 'Islas Malvinas',
  mnp: 'Islas Marianas del Norte',
  mhl: 'Islas Marshall',
  pcn: 'Islas Pitcairn',
  slb: 'Islas Salomón',
  tca: 'Islas Turcas y Caicos',
  umi: 'Islas ultramarinas de Estados Unidos',
  vgb: 'Islas Vírgenes Británicas',
  vir: 'Islas Vírgenes de los Estados Unidos',
  isr: 'Israel',
  ita: 'Italia',
  jam: 'Jamaica',
  jpn: 'Japón',
  jey: 'Jersey',
  jor: 'Jordania',
  kaz: 'Kazajistán',
  ken: 'Kenia',
  kgz: 'Kirguistán',
  kir: 'Kiribati',
  kwt: 'Kuwait',
  lao: 'Laos',
  lso: 'Lesoto',
  lva: 'Letonia',
  lbn: 'Líbano',
  lbr: 'Liberia',
  lby: 'Libia',
  lie: 'Liechtenstein',
  ltu: 'Lituania',
  lux: 'Luxemburgo',
  mac: 'Macao',
  mkd: 'Macedonia',
  mdg: 'Madagascar',
  mys: 'Malasia',
  mwi: 'Malaui',
  mdv: 'Maldivas',
  mli: 'Malí',
  mlt: 'Malta',
  mar: 'Marruecos',
  mtq: 'Martinica',
  mus: 'Mauricio',
  mrt: 'Mauritania',
  myt: 'Mayotte',
  mex: 'México',
  fsm: 'Micronesia',
  mda: 'Moldavia',
  mco: 'Mónaco',
  mng: 'Mongolia',
  mne: 'Montenegro',
  msr: 'Montserrat',
  moz: 'Mozambique',
  mmr: 'Myanmar',
  nam: 'Namibia',
  nru: 'Nauru',
  npl: 'Nepal',
  nic: 'Nicaragua',
  ner: 'Níger',
  nga: 'Nigeria',
  niu: 'Niue',
  nfk: 'Norfolk',
  nor: 'Noruega',
  ncl: 'Nueva Caledonia',
  nzl: 'Nueva Zelanda',
  omn: 'Omán',
  nld: 'Países Bajos',
  pak: 'Pakistán',
  plw: 'Palaos',
  pse: 'Palestina',
  pan: 'Panamá',
  png: 'Papúa Nueva Guinea',
  pry: 'Paraguay',
  per: 'Perú',
  pyf: 'Polinesia Francesa',
  pol: 'Polonia',
  prt: 'Portugal',
  pri: 'Puerto Rico',
  gbr: 'Reino Unido',
  esh: 'República Árabe Saharaui Democrática',
  caf: 'República Centroafricana',
  cze: 'República Checa',
  cog: 'República del Congo',
  cod: 'República Democrática del Congo',
  dom: 'República Dominicana',
  reu: 'Reunión',
  rwa: 'Ruanda',
  rou: 'Rumania',
  rus: 'Rusia',
  wsm: 'Samoa',
  asm: 'Samoa Americana',
  blm: 'San Bartolomé',
  kna: 'San Cristóbal y Nieves',
  smr: 'San Marino',
  maf: 'San Martín',
  spm: 'San Pedro y Miquelón',
  vct: 'San Vicente y las Granadinas',
  shn: 'Santa Elena, Ascensión y Tristán de Acuña',
  lca: 'Santa Lucía',
  stp: 'Santo Tomé y Príncipe',
  sen: 'Senegal',
  srb: 'Serbia',
  syc: 'Seychelles',
  sle: 'Sierra Leona',
  sgp: 'Singapur',
  sxm: 'Sint Maarten',
  syr: 'Siria',
  som: 'Somalia',
  lka: 'Sri Lanka',
  swz: 'Suazilandia',
  zaf: 'Sudáfrica',
  sdn: 'Sudán',
  ssd: 'Sudán del Sur',
  swe: 'Suecia',
  che: 'Suiza',
  sur: 'Surinam',
  sjm: 'Svalbard y Jan Mayen',
  tha: 'Tailandia',
  twn: 'Taiwán (República de China)',
  tza: 'Tanzania',
  tjk: 'Tayikistán',
  iot: 'Territorio Británico del Océano Índico',
  atf: 'Tierras Australes y Antárticas Francesas',
  tls: 'Timor Oriental',
  tgo: 'Togo',
  tkl: 'Tokelau',
  ton: 'Tonga',
  tto: 'Trinidad y Tobago',
  tun: 'Túnez',
  tkm: 'Turkmenistán',
  tur: 'Turquía',
  tuv: 'Tuvalu',
  ukr: 'Ucrania',
  uga: 'Uganda',
  ury: 'Uruguay',
  uzb: 'Uzbekistán',
  vut: 'Vanuatu',
  vat: 'Vaticano, Ciudad del',
  ven: 'Venezuela',
  vnm: 'Vietnam',
  wlf: 'Wallis y Futuna',
  yem: 'Yemen',
  dji: 'Yibuti',
  zmb: 'Zambia',
  zwe: 'Zimbabue',
};

export const COUNTRIES_LIST = [
  { value: 'afg', label: COUNTRIES_DICTIONARY.afg },
  { value: 'ala', label: COUNTRIES_DICTIONARY.ala },
  { value: 'alb', label: COUNTRIES_DICTIONARY.alb },
  { value: 'deu', label: COUNTRIES_DICTIONARY.deu },
  { value: 'and', label: COUNTRIES_DICTIONARY.and },
  { value: 'ago', label: COUNTRIES_DICTIONARY.ago },
  { value: 'aia', label: COUNTRIES_DICTIONARY.aia },
  { value: 'ata', label: COUNTRIES_DICTIONARY.ata },
  { value: 'atg', label: COUNTRIES_DICTIONARY.atg },
  { value: 'sau', label: COUNTRIES_DICTIONARY.sau },
  { value: 'dza', label: COUNTRIES_DICTIONARY.dza },
  { value: 'arg', label: COUNTRIES_DICTIONARY.arg },
  { value: 'arm', label: COUNTRIES_DICTIONARY.arm },
  { value: 'abw', label: COUNTRIES_DICTIONARY.abw },
  { value: 'aus', label: COUNTRIES_DICTIONARY.aus },
  { value: 'aut', label: COUNTRIES_DICTIONARY.aut },
  { value: 'aze', label: COUNTRIES_DICTIONARY.aze },
  { value: 'bhs', label: COUNTRIES_DICTIONARY.bhs },
  { value: 'bgd', label: COUNTRIES_DICTIONARY.bgd },
  { value: 'brb', label: COUNTRIES_DICTIONARY.brb },
  { value: 'bhr', label: COUNTRIES_DICTIONARY.bhr },
  { value: 'bel', label: COUNTRIES_DICTIONARY.bel },
  { value: 'blz', label: COUNTRIES_DICTIONARY.blz },
  { value: 'ben', label: COUNTRIES_DICTIONARY.ben },
  { value: 'bmu', label: COUNTRIES_DICTIONARY.bmu },
  { value: 'blr', label: COUNTRIES_DICTIONARY.blr },
  { value: 'bol', label: COUNTRIES_DICTIONARY.bol },
  { value: 'bes', label: COUNTRIES_DICTIONARY.bes },
  { value: 'bih', label: COUNTRIES_DICTIONARY.bih },
  { value: 'bwa', label: COUNTRIES_DICTIONARY.bwa },
  { value: 'bra', label: COUNTRIES_DICTIONARY.bra },
  { value: 'brn', label: COUNTRIES_DICTIONARY.brn },
  { value: 'bgr', label: COUNTRIES_DICTIONARY.bgr },
  { value: 'bfa', label: COUNTRIES_DICTIONARY.bfa },
  { value: 'bdi', label: COUNTRIES_DICTIONARY.bdi },
  { value: 'btn', label: COUNTRIES_DICTIONARY.btn },
  { value: 'cpv', label: COUNTRIES_DICTIONARY.cpv },
  { value: 'khm', label: COUNTRIES_DICTIONARY.khm },
  { value: 'cmr', label: COUNTRIES_DICTIONARY.cmr },
  { value: 'can', label: COUNTRIES_DICTIONARY.can },
  { value: 'qat', label: COUNTRIES_DICTIONARY.qat },
  { value: 'tcd', label: COUNTRIES_DICTIONARY.tcd },
  { value: 'chl', label: COUNTRIES_DICTIONARY.chl },
  { value: 'chn', label: COUNTRIES_DICTIONARY.chn },
  { value: 'cyp', label: COUNTRIES_DICTIONARY.cyp },
  { value: 'col', label: COUNTRIES_DICTIONARY.col },
  { value: 'com', label: COUNTRIES_DICTIONARY.com },
  { value: 'prk', label: COUNTRIES_DICTIONARY.prk },
  { value: 'kor', label: COUNTRIES_DICTIONARY.kor },
  { value: 'civ', label: COUNTRIES_DICTIONARY.civ },
  { value: 'cri', label: COUNTRIES_DICTIONARY.cri },
  { value: 'hrv', label: COUNTRIES_DICTIONARY.hrv },
  { value: 'cub', label: COUNTRIES_DICTIONARY.cub },
  { value: 'cuw', label: COUNTRIES_DICTIONARY.cuw },
  { value: 'dnk', label: COUNTRIES_DICTIONARY.dnk },
  { value: 'dma', label: COUNTRIES_DICTIONARY.dma },
  { value: 'ecu', label: COUNTRIES_DICTIONARY.ecu },
  { value: 'egy', label: COUNTRIES_DICTIONARY.egy },
  { value: 'slv', label: COUNTRIES_DICTIONARY.slv },
  { value: 'are', label: COUNTRIES_DICTIONARY.are },
  { value: 'eri', label: COUNTRIES_DICTIONARY.eri },
  { value: 'svk', label: COUNTRIES_DICTIONARY.svk },
  { value: 'svn', label: COUNTRIES_DICTIONARY.svn },
  { value: 'esp', label: COUNTRIES_DICTIONARY.esp },
  { value: 'usa', label: COUNTRIES_DICTIONARY.usa },
  { value: 'est', label: COUNTRIES_DICTIONARY.est },
  { value: 'eth', label: COUNTRIES_DICTIONARY.eth },
  { value: 'phl', label: COUNTRIES_DICTIONARY.phl },
  { value: 'fin', label: COUNTRIES_DICTIONARY.fin },
  { value: 'fji', label: COUNTRIES_DICTIONARY.fji },
  { value: 'fra', label: COUNTRIES_DICTIONARY.fra },
  { value: 'gab', label: COUNTRIES_DICTIONARY.gab },
  { value: 'gmb', label: COUNTRIES_DICTIONARY.gmb },
  { value: 'geo', label: COUNTRIES_DICTIONARY.geo },
  { value: 'gha', label: COUNTRIES_DICTIONARY.gha },
  { value: 'gib', label: COUNTRIES_DICTIONARY.gib },
  { value: 'grd', label: COUNTRIES_DICTIONARY.grd },
  { value: 'grc', label: COUNTRIES_DICTIONARY.grc },
  { value: 'grl', label: COUNTRIES_DICTIONARY.grl },
  { value: 'glp', label: COUNTRIES_DICTIONARY.glp },
  { value: 'gum', label: COUNTRIES_DICTIONARY.gum },
  { value: 'gtm', label: COUNTRIES_DICTIONARY.gtm },
  { value: 'guf', label: COUNTRIES_DICTIONARY.guf },
  { value: 'ggy', label: COUNTRIES_DICTIONARY.ggy },
  { value: 'gin', label: COUNTRIES_DICTIONARY.gin },
  { value: 'gnb', label: COUNTRIES_DICTIONARY.gnb },
  { value: 'gnq', label: COUNTRIES_DICTIONARY.gnq },
  { value: 'guy', label: COUNTRIES_DICTIONARY.guy },
  { value: 'hti', label: COUNTRIES_DICTIONARY.hti },
  { value: 'hnd', label: COUNTRIES_DICTIONARY.hnd },
  { value: 'hkg', label: COUNTRIES_DICTIONARY.hkg },
  { value: 'hun', label: COUNTRIES_DICTIONARY.hun },
  { value: 'ind', label: COUNTRIES_DICTIONARY.ind },
  { value: 'idn', label: COUNTRIES_DICTIONARY.idn },
  { value: 'irq', label: COUNTRIES_DICTIONARY.irq },
  { value: 'irn', label: COUNTRIES_DICTIONARY.irn },
  { value: 'irl', label: COUNTRIES_DICTIONARY.irl },
  { value: 'bvt', label: COUNTRIES_DICTIONARY.bvt },
  { value: 'imn', label: COUNTRIES_DICTIONARY.imn },
  { value: 'cxr', label: COUNTRIES_DICTIONARY.cxr },
  { value: 'isl', label: COUNTRIES_DICTIONARY.isl },
  { value: 'cym', label: COUNTRIES_DICTIONARY.cym },
  { value: 'cck', label: COUNTRIES_DICTIONARY.cck },
  { value: 'cok', label: COUNTRIES_DICTIONARY.cok },
  { value: 'fro', label: COUNTRIES_DICTIONARY.fro },
  { value: 'sgs', label: COUNTRIES_DICTIONARY.sgs },
  { value: 'hmd', label: COUNTRIES_DICTIONARY.hmd },
  { value: 'flk', label: COUNTRIES_DICTIONARY.flk },
  { value: 'mnp', label: COUNTRIES_DICTIONARY.mnp },
  { value: 'mhl', label: COUNTRIES_DICTIONARY.mhl },
  { value: 'pcn', label: COUNTRIES_DICTIONARY.pcn },
  { value: 'slb', label: COUNTRIES_DICTIONARY.slb },
  { value: 'tca', label: COUNTRIES_DICTIONARY.tca },
  { value: 'umi', label: COUNTRIES_DICTIONARY.umi },
  { value: 'vgb', label: COUNTRIES_DICTIONARY.vgb },
  { value: 'vir', label: COUNTRIES_DICTIONARY.vir },
  { value: 'isr', label: COUNTRIES_DICTIONARY.isr },
  { value: 'ita', label: COUNTRIES_DICTIONARY.ita },
  { value: 'jam', label: COUNTRIES_DICTIONARY.jam },
  { value: 'jpn', label: COUNTRIES_DICTIONARY.jpn },
  { value: 'jey', label: COUNTRIES_DICTIONARY.jey },
  { value: 'jor', label: COUNTRIES_DICTIONARY.jor },
  { value: 'kaz', label: COUNTRIES_DICTIONARY.kaz },
  { value: 'ken', label: COUNTRIES_DICTIONARY.ken },
  { value: 'kgz', label: COUNTRIES_DICTIONARY.kgz },
  { value: 'kir', label: COUNTRIES_DICTIONARY.kir },
  { value: 'kwt', label: COUNTRIES_DICTIONARY.kwt },
  { value: 'lao', label: COUNTRIES_DICTIONARY.lao },
  { value: 'lso', label: COUNTRIES_DICTIONARY.lso },
  { value: 'lva', label: COUNTRIES_DICTIONARY.lva },
  { value: 'lbn', label: COUNTRIES_DICTIONARY.lbn },
  { value: 'lbr', label: COUNTRIES_DICTIONARY.lbr },
  { value: 'lby', label: COUNTRIES_DICTIONARY.lby },
  { value: 'lie', label: COUNTRIES_DICTIONARY.lie },
  { value: 'ltu', label: COUNTRIES_DICTIONARY.ltu },
  { value: 'lux', label: COUNTRIES_DICTIONARY.lux },
  { value: 'mac', label: COUNTRIES_DICTIONARY.mac },
  { value: 'mkd', label: COUNTRIES_DICTIONARY.mkd },
  { value: 'mdg', label: COUNTRIES_DICTIONARY.mdg },
  { value: 'mys', label: COUNTRIES_DICTIONARY.mys },
  { value: 'mwi', label: COUNTRIES_DICTIONARY.mwi },
  { value: 'mdv', label: COUNTRIES_DICTIONARY.mdv },
  { value: 'mli', label: COUNTRIES_DICTIONARY.mli },
  { value: 'mlt', label: COUNTRIES_DICTIONARY.mlt },
  { value: 'mar', label: COUNTRIES_DICTIONARY.mar },
  { value: 'mtq', label: COUNTRIES_DICTIONARY.mtq },
  { value: 'mus', label: COUNTRIES_DICTIONARY.mus },
  { value: 'mrt', label: COUNTRIES_DICTIONARY.mrt },
  { value: 'myt', label: COUNTRIES_DICTIONARY.myt },
  { value: 'mex', label: COUNTRIES_DICTIONARY.mex },
  { value: 'fsm', label: COUNTRIES_DICTIONARY.fsm },
  { value: 'mda', label: COUNTRIES_DICTIONARY.mda },
  { value: 'mco', label: COUNTRIES_DICTIONARY.mco },
  { value: 'mng', label: COUNTRIES_DICTIONARY.mng },
  { value: 'mne', label: COUNTRIES_DICTIONARY.mne },
  { value: 'msr', label: COUNTRIES_DICTIONARY.msr },
  { value: 'moz', label: COUNTRIES_DICTIONARY.moz },
  { value: 'mmr', label: COUNTRIES_DICTIONARY.mmr },
  { value: 'nam', label: COUNTRIES_DICTIONARY.nam },
  { value: 'nru', label: COUNTRIES_DICTIONARY.nru },
  { value: 'npl', label: COUNTRIES_DICTIONARY.npl },
  { value: 'nic', label: COUNTRIES_DICTIONARY.nic },
  { value: 'ner', label: COUNTRIES_DICTIONARY.ner },
  { value: 'nga', label: COUNTRIES_DICTIONARY.nga },
  { value: 'niu', label: COUNTRIES_DICTIONARY.niu },
  { value: 'nfk', label: COUNTRIES_DICTIONARY.nfk },
  { value: 'nor', label: COUNTRIES_DICTIONARY.nor },
  { value: 'ncl', label: COUNTRIES_DICTIONARY.ncl },
  { value: 'nzl', label: COUNTRIES_DICTIONARY.nzl },
  { value: 'omn', label: COUNTRIES_DICTIONARY.omn },
  { value: 'nld', label: COUNTRIES_DICTIONARY.nld },
  { value: 'pak', label: COUNTRIES_DICTIONARY.pak },
  { value: 'plw', label: COUNTRIES_DICTIONARY.plw },
  { value: 'pse', label: COUNTRIES_DICTIONARY.pse },
  { value: 'pan', label: COUNTRIES_DICTIONARY.pan },
  { value: 'png', label: COUNTRIES_DICTIONARY.png },
  { value: 'pry', label: COUNTRIES_DICTIONARY.pry },
  { value: 'per', label: COUNTRIES_DICTIONARY.per },
  { value: 'pyf', label: COUNTRIES_DICTIONARY.pyf },
  { value: 'pol', label: COUNTRIES_DICTIONARY.pol },
  { value: 'prt', label: COUNTRIES_DICTIONARY.prt },
  { value: 'pri', label: COUNTRIES_DICTIONARY.pri },
  { value: 'gbr', label: COUNTRIES_DICTIONARY.gbr },
  { value: 'esh', label: COUNTRIES_DICTIONARY.esh },
  { value: 'caf', label: COUNTRIES_DICTIONARY.caf },
  { value: 'cze', label: COUNTRIES_DICTIONARY.cze },
  { value: 'cog', label: COUNTRIES_DICTIONARY.cog },
  { value: 'cod', label: COUNTRIES_DICTIONARY.cod },
  { value: 'dom', label: COUNTRIES_DICTIONARY.dom },
  { value: 'reu', label: COUNTRIES_DICTIONARY.reu },
  { value: 'rwa', label: COUNTRIES_DICTIONARY.rwa },
  { value: 'rou', label: COUNTRIES_DICTIONARY.rou },
  { value: 'rus', label: COUNTRIES_DICTIONARY.rus },
  { value: 'wsm', label: COUNTRIES_DICTIONARY.wsm },
  { value: 'asm', label: COUNTRIES_DICTIONARY.asm },
  { value: 'blm', label: COUNTRIES_DICTIONARY.blm },
  { value: 'kna', label: COUNTRIES_DICTIONARY.kna },
  { value: 'smr', label: COUNTRIES_DICTIONARY.smr },
  { value: 'maf', label: COUNTRIES_DICTIONARY.maf },
  { value: 'spm', label: COUNTRIES_DICTIONARY.spm },
  { value: 'vct', label: COUNTRIES_DICTIONARY.vct },
  { value: 'shn', label: COUNTRIES_DICTIONARY.shn },
  { value: 'lca', label: COUNTRIES_DICTIONARY.lca },
  { value: 'stp', label: COUNTRIES_DICTIONARY.stp },
  { value: 'sen', label: COUNTRIES_DICTIONARY.sen },
  { value: 'srb', label: COUNTRIES_DICTIONARY.srb },
  { value: 'syc', label: COUNTRIES_DICTIONARY.syc },
  { value: 'sle', label: COUNTRIES_DICTIONARY.sle },
  { value: 'sgp', label: COUNTRIES_DICTIONARY.sgp },
  { value: 'sxm', label: COUNTRIES_DICTIONARY.sxm },
  { value: 'syr', label: COUNTRIES_DICTIONARY.syr },
  { value: 'som', label: COUNTRIES_DICTIONARY.som },
  { value: 'lka', label: COUNTRIES_DICTIONARY.lka },
  { value: 'swz', label: COUNTRIES_DICTIONARY.swz },
  { value: 'zaf', label: COUNTRIES_DICTIONARY.zaf },
  { value: 'sdn', label: COUNTRIES_DICTIONARY.sdn },
  { value: 'ssd', label: COUNTRIES_DICTIONARY.ssd },
  { value: 'swe', label: COUNTRIES_DICTIONARY.swe },
  { value: 'che', label: COUNTRIES_DICTIONARY.che },
  { value: 'sur', label: COUNTRIES_DICTIONARY.sur },
  { value: 'sjm', label: COUNTRIES_DICTIONARY.sjm },
  { value: 'tha', label: COUNTRIES_DICTIONARY.tha },
  { value: 'twn', label: COUNTRIES_DICTIONARY.twn },
  { value: 'tza', label: COUNTRIES_DICTIONARY.tza },
  { value: 'tjk', label: COUNTRIES_DICTIONARY.tjk },
  { value: 'iot', label: COUNTRIES_DICTIONARY.iot },
  { value: 'atf', label: COUNTRIES_DICTIONARY.atf },
  { value: 'tls', label: COUNTRIES_DICTIONARY.tls },
  { value: 'tgo', label: COUNTRIES_DICTIONARY.tgo },
  { value: 'tkl', label: COUNTRIES_DICTIONARY.tkl },
  { value: 'ton', label: COUNTRIES_DICTIONARY.ton },
  { value: 'tto', label: COUNTRIES_DICTIONARY.tto },
  { value: 'tun', label: COUNTRIES_DICTIONARY.tun },
  { value: 'tkm', label: COUNTRIES_DICTIONARY.tkm },
  { value: 'tur', label: COUNTRIES_DICTIONARY.tur },
  { value: 'tuv', label: COUNTRIES_DICTIONARY.tuv },
  { value: 'ukr', label: COUNTRIES_DICTIONARY.ukr },
  { value: 'uga', label: COUNTRIES_DICTIONARY.uga },
  { value: 'ury', label: COUNTRIES_DICTIONARY.ury },
  { value: 'uzb', label: COUNTRIES_DICTIONARY.uzb },
  { value: 'vut', label: COUNTRIES_DICTIONARY.vut },
  { value: 'vat', label: COUNTRIES_DICTIONARY.vat },
  { value: 'ven', label: COUNTRIES_DICTIONARY.ven },
  { value: 'vnm', label: COUNTRIES_DICTIONARY.vnm },
  { value: 'wlf', label: COUNTRIES_DICTIONARY.wlf },
  { value: 'yem', label: COUNTRIES_DICTIONARY.yem },
  { value: 'dji', label: COUNTRIES_DICTIONARY.dji },
  { value: 'zmb', label: COUNTRIES_DICTIONARY.zmb },
  { value: 'zwe', label: COUNTRIES_DICTIONARY.zwe },
];

export const BOOKIES_LIST = [
  {
    key: 'BET365',
    title: 'BET365',
  },
  {
    key: 'BETFAIR',
    title: 'BETFAIR',
  },
  {
    key: 'WILLIAM_HILL',
    title: 'William Hill',
  },
  {
    key: 'SPORTIUM',
    title: 'Sportium',
  },
  {
    key: 'LUCKIA',
    title: 'Luckia',
  },
  {
    key: '888SPORT',
    title: '888Sport',
  },
  { title: 'Marathonbet', key: 'MARATHONBET' },
  { title: 'Goldenpark', key: 'GOLDENPARK' },
  { title: 'Retabet', key: 'RETABET' },
  { title: 'Kirolbet', key: 'KIROLBET' },
];
